// @flow

import { toastr } from "react-redux-toastr";
import { makeApiCall } from "../../../../../services/apiService/apiService";

const apiToastrMessages = {
  EDIT_TICKET_SUCCESS: "Ticket changes saved",
  COMMENT_SUBMIT_SUCCESS: "Comment updated successfully",
  EDIT_TICKET_EXCEPTION: "Exception in editing the ticket",
  EDIT_TICKET_FAILURE:
    "Ticket change could not be made. Please refresh and try again.",
  COMMENT_SUBMIT_FAILURE:
    "Comment could not be updated. Please refresh and try again.",
  COMMENT_SUBMIT_EXCEPTION: "Exception in submitting the ticket.",
  ESCALATE_TICKET_SUCCESS: "Ticket escalation successfully.",
  ESCALATE_TICKET_FAILED: "Ticket escalation failed.",
  ESCALATE_TICKET_EXCEPTION: "Ticket escalation exception."
};

const editOptions = {
  INTERACTION_COUNT: "INTERACTION_COUNT",
  PRIORITY: "PRIORITY",
  STATUS: "STATUS",
  ASSIGNEE: "ASSIGNEE",
  ASSIGN_TO_ME: "ASSIGN_TO_ME"
};

export const viewTicketActions = {
  GET_TICKET_DETAILS: "GET_TICKET_DETAILS",
  SEND_COMMENTS: "SEND_COMMENTS",
  GET_COMMENT_DETAILS: "GET_COMMENT_DETAILS",
  GET_ASSIGN_TO_OPTIONS: "GET_ASSIGN_TO_OPTIONS",
  PUT_TICKET_CHANGES: "PUT_TICKET_CHANGES",
  POST_TICKET_ESCALATION_EMAIL: "POST_TICKET_ESCALATION_EMAIL",
  CHECK_VALIDITY: "CHECK_VALIDITY",
  TICKET_ACTION: "TICKET_ACTION"
};

export const getTicketDetailsAction = (obj: Object) => ({
  type: viewTicketActions.GET_TICKET_DETAILS,
  payload: obj
});

export const sendCommentsAction = (obj: Object) => ({
  type: viewTicketActions.SEND_COMMENTS,
  payload: obj
});

export const getCommentDetailsAction = (obj: Object) => ({
  type: viewTicketActions.GET_COMMENT_DETAILS,
  payload: obj
});

export const getAssignToOptionsAction = (obj: Object) => ({
  type: viewTicketActions.GET_ASSIGN_TO_OPTIONS,
  payload: obj
});

export const putEditTicketChangesAction = (obj: Object) => ({
  type: viewTicketActions.PUT_TICKET_CHANGES,
  payload: obj
});

export const putTicketEscalateEmailAction = (obj: Object) => ({
  type: viewTicketActions.POST_TICKET_ESCALATION_EMAIL,
  payload: obj
});

export const checkValidityAction = (obj: Object) => ({
  type: viewTicketActions.CHECK_VALIDITY,
  payload: obj
});

export const performTicketActionAction = (load: Object) => ({
  type: viewTicketActions.TICKET_ACTION,
  payload: load
});

export const putTicketEscalateEmail = editTicketDTO => (dispatch: Function) => {
  dispatch(
    putTicketEscalateEmailAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log("Sending the ticket escalation email changes", editTicketDTO);

  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "sendTicketEscalation",
    method: "PUT",
    data: editTicketDTO,
    successCb: res => {
      //  eslint-disable-next-line
      if (res.status === "SUCCESS") {
        dispatch(
          putTicketEscalateEmailAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
        toastr.success("Success", apiToastrMessages.ESCALATE_TICKET_SUCCESS, {
          timeout: 3000
        });
      } else if (res.status === "FAILURE") {
        dispatch(
          putTicketEscalateEmailAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
        toastr.error("Failure", res.errorMessage, {
          timeout: 3000
        });
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in ticket escalation email Submit, res= ", res);
      dispatch(
        putTicketEscalateEmailAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error("Failure", res.errorMessage, {
        timeout: 3000
      });
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in ticket escalation email Submit ", res);
      dispatch(
        putTicketEscalateEmailAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error("Exception", apiToastrMessages.ESCALATE_TICKET_EXCEPTION, {
        timeOut: 3000
      });
    }
  };
  makeApiCall(requestObj);
};

export const getCommentDetails = ticketId => (dispatch: Function) => {
  dispatch(
    getCommentDetailsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log("Fetching Comment Details from Ticket Id", ticketId);

  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "sendComments",
    replaceParamsArr: [{ key: "ticketId", val: ticketId }],
    successCb: res => {
      //	eslint-disable-next-line
      console.log("Fetched all comments ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getCommentDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        dispatch(
          getCommentDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in comments fetching ", res);
      dispatch(
        getCommentDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching comments ", res);
      dispatch(
        getCommentDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const putEditTicketChanges = (editTicketDTO, changeType) => (
  dispatch: Function
) => {
  dispatch(
    putEditTicketChangesAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log("Sending the editTicket changes", editTicketDTO);

  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint:
      changeType === editOptions.ASSIGN_TO_ME
        ? "putAssignToMe"
        : "putEditTicketChanges",
    method: "PUT",
    data: editTicketDTO,
    pathVariables:
      changeType === editOptions.ASSIGN_TO_ME
        ? [{ key: "ticketId", val: editTicketDTO.id }]
        : null,
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched editTicket Submit ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getTicketDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
        toastr.success("Success", apiToastrMessages.EDIT_TICKET_SUCCESS, {
          timeOut: 3000
        });
      } else if (res.status === "FAILURE") {
        dispatch(
          putEditTicketChangesAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
        toastr.error("Failure", res.errorMessage, {
          timeout: 3000
        });
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in editTicket Submit, res= ", res);
      dispatch(
        putEditTicketChangesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );

      toastr.error("Failure", res.errorMessage, {
        timeOut: 3000
      });
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in editTicket Submit ", res);
      dispatch(
        putEditTicketChangesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );

      toastr.error("Exception", apiToastrMessages.EDIT_TICKET_EXCEPTION, {
        timeOut: 3000
      });
    }
  };
  makeApiCall(requestObj);
};

export const sendCommentsDetails = (
  formData,
  getComments,
  ticketId,
  actualFirstResponse,
  getTicketDetails
) => (dispatch: Function) => {
  dispatch(
    sendCommentsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log("Sending the comment", formData);

  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "sendComments",
    method: "POST",
    postFormData: true,
    data: formData,
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched Comment Submit ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          sendCommentsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
        if (getComments) {
          toastr.success("Success", apiToastrMessages.COMMENT_SUBMIT_SUCCESS, {
            timeOut: 3000
          });
          getComments(ticketId);
        }
        if (!actualFirstResponse && getTicketDetails) {
          getTicketDetails(ticketId);
        }
      } else if (res.status === "FAILURE") {
        dispatch(
          sendCommentsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
        toastr.error("Failure", res.errorMessage, {
          timeOut: 3000
        });
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in Comment Submit, res= ", res);
      dispatch(
        sendCommentsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error("Failure", res.errorMessage, {
        timeOut: 3000
      });
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in Comment Submit ", res);
      dispatch(
        sendCommentsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error("Exception", apiToastrMessages.COMMENT_SUBMIT_EXCEPTION, {
        timeOut: 3000
      });
    }
  };
  makeApiCall(requestObj);
};

export const getTicketDetails = ticketId => (dispatch: Function) => {
  dispatch(
    getTicketDetailsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log("Fetching Ticket Details from Ticket Id", ticketId);

  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketDetails",
    replaceParamsArr: [{ key: "ticketId", val: ticketId }],
    successCb: res => {
      //	eslint-disable-next-line
      console.log("Fetched all Ticket Types ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getTicketDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        dispatch(
          getTicketDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      toastr.error("Error", res.response);
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching oa matrics, res= ", res);
      dispatch(
        getTicketDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching oa matrics ", res);
      dispatch(
        getTicketDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getAssignToOptions = text => (dispatch: Function) => {
  dispatch(
    getAssignToOptionsAction({
      isLoading: true,
      isLoaded: false,
      data: []
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getAssigneeOptions",
    replaceParamsArr: [{ key: "pattern", val: text }],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched assign to options ", res);
      if (res.status === "SUCCESS") {
        const data = {
          isLoading: false,
          isLoaded: true,
          data: res.response
        };
        dispatch(getAssignToOptionsAction(data));
      } else if (res.status === "FAILURE") {
        dispatch(
          getAssignToOptionsAction({
            isLoading: false,
            isLoaded: true,
            data: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in assign to options, res= ", res);
      dispatch(
        getAssignToOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in assign to options ", res);
      dispatch(
        getAssignToOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const checkValidity = ticketId => (dispatch: Function) => {
  dispatch(
    checkValidityAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );

  const requestObj = {
    baseUrl: "zoomApiUrl",
    apiEndPoint: "checkEWayBillValidity",
    pathVariables: [{ key: "#ticketId", val: ticketId }],
    method: "PUT",
    successCb: res => {
      //	eslint-disable-next-line
      if (res.status === "SUCCESS") {
        toastr.success(res.payload);
        dispatch(
          checkValidityAction({
            isLoading: false,
            isLoaded: true,
            data: res.payload
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          checkValidityAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      toastr.error("Error", res.payload);
      // eslint-disable-next-line no-console
      dispatch(
        checkValidityAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      toastr.error("Error", res.payload);
      dispatch(
        checkValidityAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  return makeApiCall(requestObj);
};

export const performTicketAction = (obj: Object) => (dispatch: Function) => {
  dispatch(
    performTicketActionAction({
      performingTicketAction: true,
      performedTicketAction: false,
      data: null
    })
  );

  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "ticketaction",
    method: "POST",
    data: obj,
    successCb: res => {
      //  eslint-disable-next-line
      if (res.status === "SUCCESS") {
        dispatch(
          performTicketActionAction({
            performingTicketAction: false,
            performedTicketAction: true,
            data: res.response,
            error: null
          })
        );
      } else if (res.status === "FAILURE") {
        dispatch(
          performTicketActionAction({
            performingTicketAction: false,
            performedTicketAction: true,
            data: null,
            error: res.errorMessage || "Failed to perform action"
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      dispatch(
        performTicketActionAction({
          performingTicketAction: false,
          performedTicketAction: true,
          data: null,
          error: res.errorMessage || "Failed to perform action"
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      dispatch(
        performTicketActionAction({
          performingTicketAction: false,
          performedTicketAction: true,
          data: null,
          error: (res && res.errorMessage) || "Failed to perform action"
        })
      );
    }
  };
  return makeApiCall(requestObj);
};



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/viewTicket/viewTicketRedux/viewTicketActionCreator.js